import React, { useEffect, useState } from 'react';
import { useTabs } from '../../../../hooks/use-tabs';
import useApi from '../../../../hooks/use-api';
import { getChecklistForCompanyStudents } from '../../../../constants/routes';
import { useUser } from '../../../../hooks/use-user';
import { Tab } from 'react-bootstrap';
import TabsHeader from '../../../Tabs/TabsHeader';
import { CHECKLISTS, ChecklistType } from './types';
import MopedChecklist from './MopedChecklist';
import CarChecklist from './CarChecklist';
import MotorChecklist from './MotorChecklist';
import CarTrailerChecklist from './CarTrailerChecklist';
import TruckChecklist from './TruckChecklist';
import TruckTrailerChecklist from './TruckTrailerChecklist';
import BusChecklist from './BusChecklist';
import BusTrailerChecklist from './BusTrailerChecklist';
import TractorChecklist from './TractorChecklist';

const STUDENTS_CHECKLIST_TABS = 'students_checklist_tabs';
const DEFAULT_TAB = 'Vrachtauto';

const ChecklistOverview = () => {
	const { activeCompany } = useUser();

	const [tabs, setTabs] = useState([]);

	const { key, handleKeyChange } = useTabs(
		tabs,
		STUDENTS_CHECKLIST_TABS,
		tabs.find((tab) => tab === DEFAULT_TAB),
	);

	const [{ data: companyStudentsChecklistsByType, isLoading: loadingStudentChecklists }] =
		useApi.get(getChecklistForCompanyStudents(activeCompany.id));

	useEffect(() => {
		setTabs(
			(companyStudentsChecklistsByType || [])
				.filter(({ checklists }: ChecklistType) => checklists?.length > 0)
				.map(({ name }: ChecklistType) => name),
		);
	}, [companyStudentsChecklistsByType]);

	const list = companyStudentsChecklistsByType as ChecklistType[] | null;

	return loadingStudentChecklists ? (
		<div className="loading-spinner" />
	) : (
		<Tab.Container
			id="planning-tabs"
			activeKey={key || undefined}
			onSelect={(k) => handleKeyChange(k)}>
			<TabsHeader tabKey={key} tabs={tabs} options={{ variant: 'pills' }} />
			<Tab.Content>
				{(list || [])
					.filter((checklistType) => checklistType.checklists?.length > 0)
					.map((checklistType) => (
						<Tab.Pane key={checklistType.name} eventKey={checklistType.name}>
							{renderTable(checklistType)}
						</Tab.Pane>
					))}
			</Tab.Content>
		</Tab.Container>
	);
};

const renderTable = (checklistType: ChecklistType) => {
	if (checklistType.name === CHECKLISTS.moped) {
		return <MopedChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.motor) {
		return <MotorChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.car) {
		return <CarChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.carTrailer) {
		return <CarTrailerChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.truck) {
		return <TruckChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.truckTrailer) {
		return <TruckTrailerChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.bus) {
		return <BusChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.busTrailer) {
		return <BusTrailerChecklist checklist={checklistType} />;
	}

	if (checklistType.name === CHECKLISTS.tractor) {
		return <TractorChecklist checklist={checklistType} />;
	}
};

export default ChecklistOverview;
